








































import Pagination from "@/components/Pagination/index.vue"; // Secondary package based on el-pagination
import { Vue, Component } from "vue-property-decorator";
import path from "path";
import { deepClone } from "@/utils";
import { asyncRoutes } from "@/router";
import i18n from "@/lang";
import { AddHolidayDateReq, addHolidaysDate } from "@/api/meterCost";
import { RouteConfig } from "vue-router";
import {
  ResCode,
  PagingReq,
  MeterCost,
  RuleCost,
  HolidayDate,
} from "@/api/baseDefine";
import { ElTree, TreeData } from "element-ui/types/tree";
import { UserModule } from "@/store/modules/user";
import { ElStep } from "element-ui/types/step";
import { DeepCopy } from "../../utils/ObjectCopy";
import { DataDef } from "vue/types/options";
import { ElForm } from "element-ui/types/form";

/**
 * 包含所有功能的表单
 *
 * @export
 * @class ComplexTable
 * @extends {Vue}
 */
@Component({
  components: {
    Pagination,
  },
})
export default class Holiday extends Vue {
  private dialogAddOrUpdate = false;
  private dialogDelete = false;
  private listLoading: boolean = true;
  private total = 0;
  private holidayDate: HolidayDate = <HolidayDate>{};
  public reset() {
    this.holidayDate = <HolidayDate>{};
  }

  private onDatePickerChange() {
    if (!this.holidayDate.name) {
      this.$message.error(this.$t("notification.pleaseInputName").toString());
      return;
    }
    if (!this.holidayDate.tempDates || this.holidayDate.tempDates.length <= 0) {
      this.$message.error(
        this.$t("notification.pleasePickOneDateAtLeast").toString()
      );
      return;
    }
    let ss: string = "";
    for (let date of this.holidayDate.tempDates) {
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      let s = y + "-" + m + "-" + d;
      if (ss === "") {
        ss = s;
      } else {
        ss = ss + "," + s;
      }
    }
    this.holidayDate.dates = ss;
  }
  public dataRules = {
    name: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    tempDates: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
  };

  private validateNotNull(rule: any, value: string, callback: any) {
    if (!value || value.length <= 0) {
      callback(new Error(this.$t("validate.valueNotNull").toString()));
    } else {
      callback();
    }
  }

  private validateNotNull1(rule: any, value: string, callback: any) {
    callback();
  }

  public add() {
    (this.$refs.form as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.createMeterCost();
      } else {
        return false;
      }
    });
  }

  public async createMeterCost() {
    const res = await addHolidaysDate(<AddHolidayDateReq>{
      holidayDate: this.holidayDate,
    });
    if (res && res.code === ResCode.SUCCESS) {
      this.$notify({
        title: this.$t("common.success").toString(),
        message: this.$t("notification.addHolidaySuccess").toString(),
        type: "success",
      });
      this.$router.push("/system/Holiday");
    }
  }

  private created() {}
}
